// CSS classes for chatbot interface
export const chatbotStyles = {
  // Keyframe animations that can't be done with Tailwind
  keyframes: `
    @keyframes blink {
      0%, 50% { opacity: 1; }
      51%, 100% { opacity: 0; }
    }
  `,

  // Starry-night syntax highlighting styles
  syntaxHighlighting: `
    .pl-c { color: #6a737d; } /* comment */
    .pl-c1 { color: #005cc5; } /* constant */
    .pl-e { color: #6f42c1; } /* entity */
    .pl-en { color: #6f42c1; } /* entity name */
    .pl-k { color: #d73a49; } /* keyword */
    .pl-s { color: #032f62; } /* string */
    .pl-smi { color: #24292e; } /* storage modifier import */
    .pl-v { color: #e36209; } /* variable */
    .pl-pds { color: #032f62; } /* punctuation definition string */
    .pl-s1 { color: #032f62; } /* string other */
    .pl-mi1 { color: #22863a; } /* markup inserted */
    .pl-md { color: #b31d28; } /* markup deleted */
    .pl-mc { color: #e36209; } /* markup changed */
    .pl-mh { color: #005cc5; } /* markup heading */
    .pl-mb { color: #24292e; font-weight: bold; } /* markup bold */
    .pl-mi { color: #24292e; font-style: italic; } /* markup italic */
  `,

  // Chatbot message overrides for markdown styling
  messageOverrides: `
    /* Override some markdown styles for chatbot */
    .chatbot-message .markdown-content {
      font-family: "Creato Display", sans-serif;
      font-size: 12px;
      line-height: 16px;
    }
    
    .chatbot-message .code-block {
      margin: 8px 0;
    }
    
    .chatbot-message .code-language {
      font-size: 10px;
      padding: 2px 8px;
    }
    
    .chatbot-message .code-block code {
      font-size: 11px;
      line-height: 14px;
    }
    
    .chatbot-message .inline-code {
      font-size: 11px;
      padding: 1px 4px;
    }
    
    .chatbot-message h1,
    .chatbot-message h2,
    .chatbot-message h3,
    .chatbot-message h4,
    .chatbot-message h5,
    .chatbot-message h6 {
      margin: 8px 0 4px;
    }
    
    .chatbot-message h1 { font-size: 18px; }
    .chatbot-message h2 { font-size: 16px; }
    .chatbot-message h3 { font-size: 14px; }
    .chatbot-message h4 { font-size: 13px; }
    .chatbot-message h5 { font-size: 12px; }
    .chatbot-message h6 { font-size: 11px; }
    
    .chatbot-message ul,
    .chatbot-message ol {
      margin: 4px 0;
    }
    
    .chatbot-message blockquote {
      margin: 4px 0;
      padding: 0 8px;
    }
    
    /* Override MarkdownRenderer margins */
    .chatbot-message p {
      margin-bottom: 8px !important;
    }
    
    .chatbot-message p:last-child {
      margin-bottom: 0 !important;
    }
    
    .chatbot-message .bg-gray-50 {
      margin: 8px 0 !important;
    }
    
    .chatbot-message ul {
      margin-bottom: 8px !important;
    }
    
    .chatbot-message ul:last-child {
      margin-bottom: 0 !important;
    }
    
    .chatbot-message table {
      margin: 8px 0;
      font-size: 11px;
    }
    
    .chatbot-message th,
    .chatbot-message td {
      padding: 4px 6px;
    }
  `,
};

// Tailwind class combinations for common chatbot elements
export const chatbotClasses = {
  // Typography overrides for chatbot messages
  message: {
    content: "font-['Creato_Display'] text-[11px] leading-[14px]",
    heading1: "text-[18px] my-3",
    heading2: "text-[16px] my-3",
    heading3: "text-[14px] my-3",
    heading4: "text-[13px] my-3",
    heading5: "text-[12px] my-3",
    heading6: "text-[11px] my-3",
    paragraph: "mb-2 last:mb-0",
    list: "mb-2 last:mb-0",
    blockquote: "my-2 px-2",
    table: "my-2 text-[11px]",
    tableCell: "px-1.5 py-1",
  },

  // Code block styling
  codeBlock: {
    container: "my-2",
    language: "text-[10px] px-2 py-0.5",
    code: "text-[11px] leading-[14px]",
  },

  // Inline code styling
  inlineCode: "text-[11px] px-1 py-0.5",

  // Typing cursor
  typingCursor:
    "inline-block w-0.5 h-3.5 bg-black ml-0.5 animate-[blink_0.6s_infinite]",
};
